import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, TypeProvider } from '@angular/core';
import { DomModule } from '@nibtravel/shared/util/dom';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { DefaultGtmProvider } from './default.gtm.provider';
import { EcommerceService } from './ecommerce/ecommerce.service';
import { GTM_PROVIDER } from './models/gtm.token';

@NgModule({
  imports: [CommonModule, ModelsModule, DomModule],
  providers: [
    EcommerceService,
    { provide: GTM_PROVIDER, useClass: DefaultGtmProvider },
  ],
})
export class GtmModule {
  static forRoot(provider: TypeProvider): ModuleWithProviders<GtmModule> {
    return {
      ngModule: GtmModule,
      providers: [{ provide: GTM_PROVIDER, useClass: provider }],
    };
  }
}
